var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarcodeIconGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5f00a0",
    fillRule: "nonzero",
    d: "M.5 0a.5.5 0 0 0-.5.5V6h1V1h5V0H.5zM25.5 0H20v1h5v5h1V.5a.5.5 0 0 0-.5-.5zM1 25v-5H0v5.5a.5.5 0 0 0 .5.5H6v-1H1zM25 20v5h-5v1h5.5a.5.5 0 0 0 .5-.5V20h-1z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#5f00a0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.5h1v19h-1zM5.5 3.5h1v19h-1zM8.5 3.5h1v19h-1zM10.5 3.5h1v19h-1zM13.5 3.5h1v19h-1zM15.5 3.5h1v19h-1zM20.5 3.5h1v19h-1zM23.5 3.5h1v19h-1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeIconGreen);
export default __webpack_public_path__ + "static/media/barcode_icon_green.7f88d6c35345fbc76cdd32399eca21e2.svg";
export { ForwardRef as ReactComponent };